import { Link } from 'react-router-dom';
import { useLocalstorageState } from 'rooks';

import { useSelf } from '@/data/user';

import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { Switch } from '@/components/ui/switch';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription
} from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { PlusCircle } from 'lucide-react';

import Page from '@/components/layout/Page';
import PageLoading from '@/components/layout/PageLoading';

import LogoutButton from '@/components/common/LogoutButton';

import CoachSettings from './CoachSettings';

const Settings = () => {
  const self = useSelf();
  const [isDarkMode, setIsDarkMode] = useLocalstorageState(`dark-mode`, false);

  if (self.isLoading && !self.data) {
    return <PageLoading />;
  }

  const handleToggleDarkMode = () => {
    setIsDarkMode((prevMode) => !prevMode);
  };

  const initials = `${self.data.firstname.charAt(0)}${self.data.lastname.charAt(
    0
  )}`;

  return (
    <Page>
      <header className="shadow-sm px-4 py-3 flex items-center justify-between bg-muted rounded mb-4">
        <div className="flex items-center gap-3">
          <Avatar className="w-8 h-8">
            <AvatarImage src="/placeholder-user.jpg" />
            <AvatarFallback>{initials}</AvatarFallback>
          </Avatar>
          <Link
            to="/setting/profile"
            className="text-sm font-medium text-gray-900 dark:text-gray-50"
          >
            {self.data.firstname} {self.data.lastname}
          </Link>
        </div>
        <Link
          to="/setting/profile"
          className="text-sm font-medium text-primary"
        >
          View Profile
        </Link>
      </header>
      <Card className="mb-4">
        <CardHeader>
          <CardTitle className="text-lg">General</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Email:</span>
            <span>{self.data.email}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Password:</span>
            <span>********</span>
          </div>
          <div className="flex gap-2 items-center justify-end pt-4">
            <Label htmlFor="dark-mode" className="font-normal">
              Dark Mode
            </Label>
            <Switch
              id="dark-mode"
              checked={isDarkMode}
              onCheckedChange={handleToggleDarkMode}
            />
          </div>
          <div className="flex justify-end pt-8">
            <LogoutButton />
          </div>
        </CardContent>
      </Card>

      {self.data.coach && <CoachSettings />}
      {!self.data.coach && (
        <Card className="w-full">
          <CardHeader>
            <CardTitle className="text-2xl">Pro Settings</CardTitle>
            <CardDescription>
              Manage your ProFound Pro profile and activities
            </CardDescription>
            <CardContent className="px-0 py-6">
              <Link to="/application/add" className="w-full">
                <Button className="w-full" variant="outline">
                  <PlusCircle className="h-4 w-4 mr-2" />
                  Apply to become a Pro
                </Button>
              </Link>
            </CardContent>
          </CardHeader>
        </Card>
      )}

      <div className="py-12"></div>
    </Page>
  );
};

export default Settings;
